import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { InspectionsComponent } from './insp.component';
import { InspFiltersComponent } from './inspection-filters/insp-filters.component';

import { ListService } from '../list.service';

import { AngularMaterialModule } from '../angular-material.module';
import { StripHtmlPipe } from '../pipes/stripHTMLpipe';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AngularMaterialModule
  ],
  providers: [
    InspFiltersComponent,
    StripHtmlPipe,
    ListService
  ],
  declarations: [
    InspectionsComponent,
    InspFiltersComponent,
    StripHtmlPipe
  ],
  exports: [
    InspectionsComponent,
    StripHtmlPipe
  ]
})
export class InspectionsModule { }
